<div class="navigation">
  <ul role="tablist" class="nav nav-tabs main full-width" style="font-size: 1em; margin-bottom: 3px;">
    <li role="presentation" class="menu-tab" [class.active]="extraTab === 'campaign'">
      <a (click)="selectTab('campaign')"><span>Quest & Gem Tracker</span></a>
    </li>
  </ul>
</div>

<div style="clear: both">
  @if (extraTab === 'campaign') {
    <app-campaign [filter]="filter"></app-campaign>
  }
</div>
